import { Users, Clock, TrendingUp, Heart, Wrench, GraduationCap } from 'lucide-react';

export var benefits = [
  {
    id: "team",
    Icon: Users,
    title: "Junges, dynamisches Team",
    description: "Arbeite in einem modernen, kollegialen Umfeld mit flachen Hierarchien und echtem Teamgeist."
  },
  {
    id: "entwicklung",
    Icon: TrendingUp,
    title: "Karriere & Weiterbildung",
    description: "Wir investieren in deine Zukunft mit regelm\u00e4\u00dfigen Schulungen, Zertifizierungen und individuellen Entwicklungsm\u00f6glichkeiten."
  },
  {
    id: "work-life",
    Icon: Clock,
    title: "Work-Life-Balance",
    description: "Geregelte Arbeitszeiten, faire Verg\u00fctung und ein wertsch\u00e4tzendes Arbeitsklima."
  },
  {
    id: "ausstattung",
    Icon: Wrench,
    title: "Moderne Ausstattung",
    description: "Hochwertige Werkzeuge, aktuelle Fahrzeugflotte und digitale Arbeitsprozesse."
  },
  {
    id: "sicherheit",
    Icon: Heart,
    title: "Sicherheit & Stabilit\u00e4t",
    description: "Unbefristete Vertr\u00e4ge und ein wachsendes Unternehmen mit langfristiger Perspektive."
  },
  {
    id: "projekte",
    Icon: GraduationCap,
    title: "Spannende Projekte",
    description: "Von Gewerbeobjekten \u00fcber Sicherheitstechnik bis zu individuellen Kundenl\u00f6sungen \u2013 Abwechslung garantiert."
  }
];

export var jobs = [
  {
    id: "initiativ",
    title: "Initiativbewerbung",
    subtitle: "Alle Bereiche",
    type: "Offen",
    description: "Du passt zu uns, findest aber nicht die passende Stelle? Bewirb dich initiativ! Wir sind immer auf der Suche nach motivierten Talenten, die unser Team verst\u00e4rken m\u00f6chten.",
    tasks: [],
    requirements: []
  },
  {
    id: "azubi-initiativ",
    title: "Initiativbewerbung Ausbildung",
    subtitle: "Alle Ausbildungsberufe",
    type: "Ausbildung",
    description: "Du suchst einen Ausbildungsplatz im Elektrohandwerk? Bewirb dich initiativ bei uns \u2013 wir freuen uns auf motivierte Nachwuchstalente, die mit uns durchstarten wollen.",
    tasks: [],
    requirements: []
  }
];
